import React from 'react';
import styles from '../../../styles/DashboardStyles/Header.module.css';

import menu from "./assets/menu.png"
import coin from './assets/coin.png';
import notif from './assets/notif.png';
import profile from './assets/profile.png';
import expand from './assets/expand.png';

const Header = ({ userData, toggleMenu, openNotifyModal, openProfileModal , toggleMobileSidebar}) => {
    console.log(userData);
    console.log("header")
    return (
        <div className={styles.header}>
            <div className={styles.left}>
                {/* to implement - expanded & collpase */}
                <div className={styles.menugrid} onClick={toggleMenu}>
                    <img src={menu} alt="Menu" />
                </div>
                <div
                    className={styles.mobileMenugrid}
                    onClick={toggleMobileSidebar}
                >
                    <img src={menu} alt="Menu" />
                </div>
                {/* <div className={styles.searchbar}>
                    <input className={styles.searchbarInput} type="text" placeholder="Search" />
                </div> */}
            </div>
            <div className={styles.right}>
                {/* <div className={styles.coins}>
                    <img src={coin} height={25} alt="Coin" /> {totalCoins}
                </div> */}
                {/* <div className={styles.maximise}>
                    <img src={expand} height={25} alt="Expand" />
                </div> */}
                {/* <div
                    onClick={openNotifyModal}
                    className={styles.notifications}>
                    <img src={notif} height={30} alt="Notifications" />
                </div> */}
                <div
                    onClick={openProfileModal}
                    className={styles.profile}>
                    <img src={userData?.photoUrl || profile} alt="Profile" />
                </div>
            </div>
        </div>
    );
};

export default Header;
